<template>
    <div class="info-popup__card">
        <div class="info-popup__card__content">
            <h2 class="grey--text">{{ getTypes[item.type].name | capitalize }}</h2>

            <h1>{{ item.name }}</h1>

            <img class="cover" :src="item.preview" :alt="item.name">

            <div
                v-if="item.type !== 'courses' && item.timeStatus !== 'past'"
                class="date"
            >{{ item.datetimeBegin | isoWithTime }}
                <template
                    v-if="item.datetimeEnd && item.datetimeEnd !== item.datetimeBegin"
                > — {{ item.datetimeEnd | isoWithTime }}</template>
            </div>

            <article class="html-block" v-html="item.description"></article>
            
            <button class="close-btn" @click="closeInfo">Понятно</button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

const getters = [
    'getTypes',
];

export default {
    name: "EventInfo",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        
    }),
    computed: {
        ...mapGetters('events', getters),
    },
    methods: {
        closeInfo() {
            this.$emit('close', false);
        },
    },
};
</script>

<style lang="scss">
@import "@/styles/rem";
@import "@/styles/mrem";

.info-popup {
    &__card {
        width: rem(870);
        background-color: #ffffff;

        @include on-mobile {
            width: 100%;
            margin-top: 0;
            max-height: calc(100vh - 15rem);
        }

        &__content {
            display: flex;
            flex-direction: column;
            align-items: center;

            @include on-mobile {
                padding: mrem(24) mrem(16);
            }
        }

        .close-btn {
            border: 1px solid #4663AB;
            border-radius: 4px;
            height: rem(48);
            width: rem(257);
            font-family: "Montserrat",sans-serif;
            font-style: normal;
            font-weight: bold;
            font-size: rem(16);
            line-height: rem(20);
            text-align: center;
            color: #4663AB;
            background-color: white;
            cursor: pointer;

            @include on-mobile {
                height: mrem(48);
                width: mrem(257);
                font-size: mrem(16);
                line-height: mrem(20);
            }
        }

        .cover {
            width: 100%;
            height: auto;
            margin-top: rem(8);
            margin-bottom: rem(24);

            @include on-mobile {
                height: mrem(193);
                margin-top: mrem(8);
                margin-bottom: mrem(16);
            }
        }

        h1 {
            font-family: "Montserrat";
            font-weight: 600;
            font-size: rem(24);
            line-height: rem(32);
            text-align: center;
            color: #2A2626;
            margin-top: rem(8);
            margin-bottom: rem(32);

            @include on-mobile {
                font-size: mrem(21);
                line-height: mrem(26);
                margin-top: mrem(8);
                margin-bottom: mrem(24);
            }
        }

        h2 {
            font-family: "Montserrat";
            font-weight: 600;
            font-size: rem(18);
            line-height: rem(22);
            color: #2A2626;
            margin-top: rem(8);
            margin-bottom: rem(24);

            @include on-mobile {
                font-size: mrem(16);
                line-height: mrem(20);
                margin-top: mrem(8);
                margin-bottom: mrem(8);
            }
        }

        h3 {
            font-family: "Montserrat";
            font-weight: 600;
            font-size: rem(18);
            line-height: rem(22);
            color: #2A2626;
            margin-bottom: rem(16);
        }

        .grey--text {
            color: #98A0A9;
        }

        article {
            white-space: pre-wrap;
            width: 100%;
            font-family: "Open Sans";
            font-size: rem(16);
            line-height: rem(26);
            color: #2A2626;
            margin-bottom: rem(32);

            @include on-mobile {
                font-size: 15px;
                line-height: 24px;
                margin-top: mrem(8);
                margin-bottom: mrem(32);
            }
        }
    }
}
</style>
